import React from 'react';
import ModalWrapper from '../ModalWrapper';
import ModalCustomMessageBody from './ModalCustomMessageBody';


const ModalCustomMessage = ({title, message, textButton, isOpen, onCloseModal, redirectOnClose = true}) => (
    <ModalWrapper isOpen={isOpen} cssClass="modal-inactivity">
        <ModalCustomMessageBody
            title={title}
            message={message}
            textButton={textButton}
            onCloseModal={onCloseModal}
            redirectOnClose={redirectOnClose}
        />
    </ModalWrapper>
);

export default ModalCustomMessage;